// ============================================================================
// FIBONACCI - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'fibonacci',
  name: 'Fibonacci',
  category: 'Dynamic Programming',
  complexity: {
    time: 'O(N)',
    space: 'O(1)'
  },
  description: 'A classic dynamic programming example that computes the nth Fibonacci number. It demonstrates memoization and tabulation techniques to avoid the exponential time complexity of the naive recursive approach.'
};
